import { FormControlLabel, Grid, TextField as MuiTextField } from '@material-ui/core';
import { TextField, Checkbox } from 'formik-material-ui';
import { Autocomplete } from 'formik-material-ui-lab';
import { Field, useFormikContext } from 'formik';
import { useContext } from 'react';
import { applicationContext } from 'helpers/services';
import { Distributor, distributorContext } from '../DistributorContext';

let DistributorForm = () => {
    let form = useFormikContext<Distributor>();

    let appService = useContext(applicationContext);
    let { isNew } = useContext(distributorContext);


    return (
        <>
            <Field
                label="Email"
                name="email"
                disabled={isNew === false}
                component={TextField}
                fullWidth
                margin="normal"
            />
            <Grid container spacing={1} alignItems="flex-end">
                <Grid item xs={6}>
                    <Field
                        label="Firstname"
                        name="firstName"
                        component={TextField}
                        fullWidth
                        margin="normal"
                    />
                </Grid>
                <Grid item xs={6}>
                    <Field
                        label="Lastname"
                        name="lastName"
                        component={TextField}
                        fullWidth
                        margin="normal"
                    />
                </Grid>
            </Grid>
            <Field
                label="Company"
                name="companyName"
                component={TextField}
                fullWidth
                margin="normal"
            />

            <Grid container item xs>
                <FormControlLabel
                    label="Can Add Dealers"
                    control={<Field type="checkbox" name="canAddDealers" component={Checkbox} />}
                />
            </Grid>

            <Field
                name="countries"
                component={Autocomplete}
                multiple
                options={appService.referenceData.availableCountries.map(x => x.key)}
                getOptionSelected={(option: string, value: string) => option === value}
                getOptionLabel={(option: string) => appService.referenceData.availableCountries.getValueByKey(option)}
                renderInput={(params: any) =>
                    <MuiTextField
                        {...params}
                        size="small"
                        margin="normal"
                        error={form.touched['countries'] && !!form.errors['countries']}
                        helperText={form.errors['countries']}
                        label="Countries"
                    />
                }
            />

            <Field
                name="brands"
                component={Autocomplete}
                multiple
                options={appService.referenceData.brands.map(x => x.key)}
                getOptionSelected={(option: string, value: string) => option === value}
                getOptionLabel={(option: string) => appService.referenceData.brands.getValueByKey(option)}
                renderInput={(params: any) =>
                    <MuiTextField
                        {...params}
                        size="small"
                        margin="normal"
                        error={form.touched['brands'] && !!form.errors['brands']}
                        helperText={form.errors['brands']}
                        label="Brands"
                    />
                }
            />
        </>
    )
}

export default DistributorForm;